import { FC, useId } from 'react';

import { FastContactForm } from '@/entities/contact/components/FastContactForm';
import { ContactType } from '@/shared/lib/sj-orm';
import { Button } from '@/shared/uikitV2/Button';
import { useTranslation } from '@/shared/utils/i18n/useTranslation';

import { BtnClose } from '../../components/BtnClose';

import { Body, Container, Footer, Header, StyledDrawer, StyledTitle } from './styled';

type CreateContactProps = {
  type?: ContactType;
  setOpen: (open: boolean) => void;
};

export const CreateContact: FC<CreateContactProps> = ({ type, setOpen }) => {
  const { t } = useTranslation('widgets/modals', { keyPrefix: 'fastCreateContact' });
  const formId = useId();

  const handleClose = () => {
    setOpen(false);
  };

  if (!type) return null;

  return (
    <StyledDrawer width={400} footer={null} closable={false} onClose={handleClose} open>
      <Container>
        <Header>
          <BtnClose onClick={handleClose} style={{ position: 'absolute', right: 24, top: 24 }} />
          <StyledTitle className="truncate" size={22} bold>
            {t('title')}
          </StyledTitle>
        </Header>
        <Body>
          <FastContactForm type={type} formId={formId} onClose={() => setOpen(false)} />
        </Body>
        <Footer>
          <Button type="text" onClick={handleClose}>
            {t('btnCancel')}
          </Button>
          <Button htmlType="submit" form={formId}>
            {t('btnSave')}
          </Button>
        </Footer>
      </Container>
    </StyledDrawer>
  );
};
